import createVueComponent from '../createVueComponent';
export default createVueComponent('align-right', 'IconAlignRight', [
  ['path', { d: 'M4 6l16 0', key: 'svg-0' }],
  ['path', { d: 'M10 12l10 0', key: 'svg-1' }],
  ['path', { d: 'M6 18l14 0', key: 'svg-2' }],
]);
